<template>
  <div>
    <el-tree
      @node-click="handleNodeClick"
      :props="props"
      :load="loadNode"
      node-key="dicValue"
      :default-expanded-keys="[1]"
      draggable
      lazy
    >
    </el-tree>
  </div>
</template>

<script>
import {
  getAllContractDict,
  getMajorContractDict,
  getConstruLaborDict,
  qryQualOtherDict,
} from "@/api/subcontractor-register";
export default {
  props: {
    treeData: {
      default: [],
      type: Array,
    },
  },
  mounted() {},
  data() {
    return {
      currentName: "",
      qualificationType: [],
      props: {
        label: "dicValue",
        children: "zones",
        isLeaf: "leaf",
      },
    };
  },
  methods: {
    handleNodeClick(data, node, b) {
      //   alert(node.level)
      if (node.level == 2) {
        //   this.currentName=data.dicValue
        this.$emit("getnode", data.dicValue, node.parent.label);
      } else {
        this.$emit("getnode", "");
      }
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([
          { dicValue: "总承包", id: 1 },
          { dicValue: "专业承包", id: 2 },
          { dicValue: "施工劳务", id: 3 },
          { dicValue: "其他", id: 4 }
        ]);
      }
      if (node.level >= 1 && node.label == "总承包") {
        getAllContractDict({}).then((res) => {
          if (res.data.code == "0") {
            res.data.data.forEach((item) => {
              item.leaf = true;
            });
            return resolve(res.data.data);
          }
        });
      }
      if (node.level >= 1 && node.label == "专业承包") {
        getMajorContractDict({}).then((res) => {
          if (res.data.code == "0") {
            res.data.data.forEach((item) => {
              item.leaf = true;
            });
            return resolve(res.data.data);
          }
        });
      }
      if (node.level >= 1 && node.label == "施工劳务") {
        getConstruLaborDict({}).then((res) => {
          if (res.data.code == "0") {
            res.data.data.forEach((item) => {
              item.leaf = true;
            });
            return resolve(res.data.data);
          }
          return resolve(arr);
        });
      }
      if (node.level >= 1 && node.label == "其他") {
        qryQualOtherDict({}).then((res) => {
          if (res.data.code == "0") {
            res.data.data.forEach((item) => {
              item.leaf = true;
            });
            return resolve(res.data.data);
          }
          return resolve(arr);
        });
      }
    },
  },
};
</script>
